var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.03672274,-0.03278978)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.015234,
    cy: 15.97518,
    rx: 15.821079,
    ry: 15.784958,
    fill: "#ff7600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#ff7600",
    width: 4.6782756,
    height: 24.399446,
    x: 14.03276,
    y: 3.0771787,
    d: "m 14.970789,3.0771787 2.943335,0 a 0.79691095,0.79691095 45 0 1 0.796911,0.796911 l 0,22.6097123 a 0.99282303,0.99282303 135 0 1 -0.992823,0.992823 h -2.56176 A 1.1236922,1.1236922 45 0 1 14.03276,26.352933 V 4.0152081 a 0.93802937,0.93802937 135 0 1 0.938029,-0.9380294 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "none",
    d: "m 10.296361,22.634878 h 9.976524 v 1.460883 a 0.26256777,0.26256777 24.265369 0 0 0.436445,0.196745 l 4.810142,-4.251055 a 0.67139064,0.67139064 89.999997 0 0 0,-1.006161 l -4.7896,-4.232901 a 0.13891128,0.13891128 155.73463 0 0 -0.230901,0.104088 l 0,1.629718 H 10.085716 a 0.97739541,0.97739541 135.002 0 0 -0.9773951,0.977327 l -2.743e-4,3.932959 a 1.1883142,1.1883142 45.001998 0 0 1.1883144,1.188397 z",
    transform: "matrix(1.1216491,0,0,1,-1.5861676,0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.879357,7.9785321 H 11.759536 V 6.5795956 A 0.29026017,0.29026017 24.24818 0 0 11.27693,6.3622158 L 6.6697523,10.438824 a 0.84952091,0.84952091 89.999992 0 0 2e-7,1.272436 l 4.5018905,3.983444 a 0.21777053,0.21777053 155.75181 0 0 0.36208,-0.163091 v -1.454396 h 10.294375 c 0.59783,0 1.082478,-0.484615 1.08252,-1.082445 l 2.78e-4,-3.9846288 c 4e-5,-0.5697314 -0.461808,-1.031611 -1.031539,-1.0316111 z",
    transform: "matrix(1.1229998,0,0,1,-1.7902718,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourButtonIcon);
export default __webpack_public_path__ + "static/media/tour-button-icon.221fea0ebb464b8c514f39b971632e33.svg";
export { ForwardRef as ReactComponent };